import { render, staticRenderFns } from "./ordersWait.vue?vue&type=template&id=91f69d64"
import script from "./ordersWait.vue?vue&type=script&lang=js"
export * from "./ordersWait.vue?vue&type=script&lang=js"
import style0 from "./ordersWait.vue?vue&type=style&index=0&id=91f69d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports